import React, { Component } from "react";

//components
import CustomCheckBox from "../../../../../generic_components/components/check_boxes/CustomCheckBox";
import HtmlTextBlock from "../../../../../generic_components/components/text_display/HtmlTextBlock";
import CustomButton from "../../../../../generic_components/components/buttons/CustomButton";
import LoadingPgTemplate from "../../../../../generic_components/view/LoadingPgTemplate";
import CariMainPgFooterView from "../../cari_template_view/CariMainPgFooterView";

//moment js
import moment from "moment";


//generic functions
import {
    isEmpty
} from "../../../../../functions/generic_functions";

/*
    props:
        pageLoaded => conditional rendering upon api load
        onChangeSetParentState => function to set parent state
        onClickCreateApp => function to create the application form on submission of consent
        consentCheckBoxes => json obj of the 3 consent checkboxes on this page
        postData => the position_id
        staticUiData => staticUiData json, all static loaded ui data for dropdowns, radio btns, etc 
        positionData: {
            position_id => position_id_val
            position_title => position_title_val
        }

        onClickCreateApplication => function to call on submit
*/
class CariAppFormViewPg0 extends Component {

    constructor(props) {
        super(props);
        this.convertDateToReadableFormat = this.convertDateToReadableFormat.bind(this);
        this.renderDateDeadline = this.renderDateDeadline.bind(this);
    }

    convertDateToReadableFormat(dateStr) {
        return moment(dateStr).format('MMMM D, YYYY');
    }

    renderDateDeadline(dateStr) {
        return (
            <React.Fragment>
                {this.convertDateToReadableFormat(dateStr) + " at 11:59 PM PST "}
            </React.Fragment>
        )
    }


    render() {
        return (
            <div className="scene_element scene_element--fadeinright">
                {(!this.props.pageLoaded) ?
                    <LoadingPgTemplate />
                : null}
               
                <div className={(this.props.pageLoaded) ? "" : "display_none"}>
                    <br/><br/>

                    <label className="cari_section_title_format"> 
                        Position Information
                    </label>
                    <div className={"cari_small_text"}>
                        <p>
                            You are applying for the following position at Simon Fraser University:
                        </p>

                        <div className="p-grid">
                            <div className="p-col-2">
                                <strong>
                                    Position Title:
                                </strong>
                            </div>
                            <div className="p-col-10">
                                {this.props.positionData.position_title}
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-2">
                                <strong>
                                    Area(s):
                            </strong>
                            </div>
                            <div className="p-col-10">
                                {this.props.staticUiData.area}
                            </div>
                        </div>

                        {(!isEmpty(this.props.staticUiData.initial_deadline) ?
                            <div className="p-grid">
                                <div className="p-col-2">
                                    <strong>
                                        Conference Deadline: &nbsp;
                                    </strong>
                                </div>
                                <div className="p-col-10">
                                    {this.renderDateDeadline(this.props.staticUiData.initial_deadline)}
                                </div>
                            </div>
                        : null)}

                        {(!isEmpty(this.props.staticUiData.late_app_deadline) ?
                            <div className="p-grid">
                                <div className="p-col-2">
                                    <strong>
                                        Final Deadline: &nbsp;
                                    </strong>
                                </div>
                                <div className="p-col-10">
                                    {this.renderDateDeadline(this.props.staticUiData.late_app_deadline)}
                                </div>
                            </div>
                            :
                            <div className="p-grid">
                                <div className="p-col-2">
                                    <strong>
                                        Final Deadline: &nbsp;
                                    </strong>
                                </div>
                                <div className="p-col-10">
                                    Open until filled
                                </div>
                            </div>
                        )}
                        
                        
                        {(!isEmpty(this.props.staticUiData.requiredDocuments) 
                            && this.props.staticUiData.requiredDocuments.length > 0 ) ?
                            <div className="p-grid">
                                <div className="p-col-12">
                                    <p className={"cari_small_text"}>
                                        This application will require you to provide the following documents:
                                    </p>
                                    <div className={"cari_small_text"}>
                                        {this.props.staticUiData.requiredDocuments.map(function (data, i) {
                                            return (
                                                <ul key={i}>
                                                    <li>
                                                        {data}
                                                    </li>
                                                </ul>
                                            );
                                        }.bind(this))}
                                    </div>
                                </div>
                            </div>
                        : <br />}

                        <div className="p-grid">
                            <div className="p-col-12">
                                <HtmlTextBlock
                                    text={this.props.staticUiData.intro_page_general_notes_text}
                                    className={"cari_small_text"}
                                />
                            </div>
                        </div>

                        <br/><br/>

                        <label className="cari_section_title_format"> 
                            Privacy Statement 
                        </label>
                        <div className="">
                            <div className="p-grid cari_form_row_padding">
                                <div className="p-col-12">
                                    <HtmlTextBlock
                                        text={this.props.staticUiData.privacy_statement_text}
                                        className={"cari_small_text"}
                                    />
                                </div>
                            </div>
                        </div>

                        <br/>

                        <label className="cari_section_title_format">
                            Retention of Records 
                        </label>
                        <div className="">
                            <div className="p-grid cari_form_row_padding">
                                <div className="p-col-12">
                                    <HtmlTextBlock
                                        text={this.props.staticUiData.retention_of_records_text}
                                        className={"cari_small_text"}
                                    />
                                </div>
                            </div>
                        </div>

                        <br/>

                        <label className="cari_section_title_format"> 
                            Consent 
                        </label>
                        <br/>
                        <div className="">
                            <div className="p-grid cari_form_row_padding">
                                <div className="p-col-12">
                                    <div className="p-grid">
                                        <div className="p-col-1 consent_checkbox_margin">
                                            <CustomCheckBox
                                                name={"privacy_aggreement_checkbox_val"}
                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                checked={this.props.postData.privacy_aggreement_checkbox_val}
                                            />
                                        </div>
                                        <div className="p-col-11">
                                            <HtmlTextBlock
                                                text={this.props.staticUiData.privacy_aggreement_checkbox_text}
                                                className={"cari_small_text"}
                                            />
                                        </div>
                                    </div>

                                    <br />

                                    <div className="p-grid">
                                        <div className="p-col-1 consent_checkbox_margin">
                                            <CustomCheckBox
                                                name={"content_consent_checkbox_val"}
                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                checked={this.props.postData.content_consent_checkbox_val}
                                            />
                                        </div>
                                        <div className="p-col-11">
                                            <HtmlTextBlock
                                                text={this.props.staticUiData.content_consent_checkbox_text}
                                                className={"cari_small_text"}
                                            />
                                        </div>
                                    </div>

                                    <br />

                                    <div className="p-grid">
                                        <div className="p-col-1 consent_checkbox_margin">
                                            <CustomCheckBox
                                                name={"policies_and_procedures_consent_checkbox_val"}
                                                onChangeSetParentState={this.props.onChangeSetParentState}
                                                checked={this.props.postData.policies_and_procedures_consent_checkbox_val}
                                            />
                                        </div>

                                        <div className="p-col-11">
                                            <HtmlTextBlock
                                                text={this.props.staticUiData.policies_and_procedures_consent_checkbox_text}
                                                className={"cari_small_text"}
                                            />
                                        </div>
                                    </div>

                                    <br />

                                </div>
                            </div>
                        </div>

                       

                        <div className="p-grid">
                            <div className="p-col-2">
                                {/* empty space */}
                            </div>
                            <div className="p-col-8">
                                <CustomButton
                                    onClickSetParentState={this.props.onClickCreateApplication}
                                    disabled={!this.props.postData.privacy_aggreement_checkbox_val || 
                                        !this.props.postData.content_consent_checkbox_val ||
                                        !this.props.postData.policies_and_procedures_consent_checkbox_val }
                                    btnRaised={true}
                                    textOnly={true}
                                    className={"p-button-success cari_start_app_btn_format"}
                                    label={"Start Application"}
                                />
                            </div>
                            <div className="p-col-2">
                                {/* empty space */}
                            </div>
                        </div>
                    </div>
                </div>

                <CariMainPgFooterView />
            </div>
        );
    }
}
export default CariAppFormViewPg0;